import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-epb-kotlov',
  templateUrl: './epb-kotlov.component.html',
  styleUrls: ['./epb-kotlov.component.scss']
})
export class EpbKotlovComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
